import { render, staticRenderFns } from "./QuestionMenu.vue?vue&type=template&id=38976783&"
import script from "./QuestionMenu.vue?vue&type=script&lang=js&"
export * from "./QuestionMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMenu.vue?vue&type=style&index=0&id=38976783&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports